import { useRef, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField
} from "../../../components";

const ButtonFiltroAvancado = ({
  buscaFiltro,
  setBuscaFiltro,
  sendServer,
  columns,
  filtrarListaPorCnpj,
}) => {
  let colunaFiltroSimples = columns.find((column) => column.filtrar);
  const inputCodigo = useRef();
  const [tipoBusca, setTipoBusca] = useState(colunaFiltroSimples.field);
  const filtros = {
    orderBy: "updatedAt",
    order: "desc",
    page: "1",
  };

  const handleChange = (event) => {
    setTipoBusca(event.target.value);
  };

  const onSearchChangeCnpj = (event) => {
    if (
      event.key === "Enter" &&
      inputCodigo.current === document.activeElement
    ) {
      const tamanhoString = event.target?.value?.length;
      if (tamanhoString === 0 || tamanhoString > 2) {
        filtrarListaPorCnpj(event.target?.value);
      }
    }
  };

  const labelPesquisar = () => {
    return colunaFiltroSimples
      ? `Pesquisar por ${colunaFiltroSimples.headerName}`
      : "Pesquisar";
  };

  const pesquisar = (e) => {
    e.preventDefault();
    const tipoFiltro = "simples";
    filtros.page = "1";
    if (buscaFiltro) {
      let queryBusca = {};
      if (colunaFiltroSimples) {
        queryBusca[colunaFiltroSimples.field] = buscaFiltro;
      }
      const retorno = {
        tipoFiltro,
        filtros: {
          ...filtros,
          ...queryBusca,
        },
      };
      sendServer(retorno);
    } else {
      sendServer({ tipoFiltro, filtro: filtros });
    }
  };

  return (
    <div className="d-flex flex-row align-items-center my-1">
      <div>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={tipoBusca}
            onChange={handleChange}
          >
            <FormControlLabel
              value="cnpj"
              control={<Radio />}
              label="CNPJ"
            />
            <FormControlLabel
              value={colunaFiltroSimples.field}
              control={<Radio />}
              label={colunaFiltroSimples.headerName}
            />
          </RadioGroup>
        </FormControl>
      </div>
      <div className="p-2">
        {tipoBusca === "cnpj" ? (
          <TextField
            id="pesquisaCnpj"
            label="Pesquisar por CNPJ"
            variant="outlined"
            margin="normal"
            onKeyDown={(e) => onSearchChangeCnpj(e)}
            inputRef={inputCodigo}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      filtrarListaPorCnpj(
                        document.getElementById("pesquisaCnpj")?.value
                      );
                    }}
                  >
                    <i
                      className="ph-bold ph-magnifying-glass"
                      style={{ color: "#494C62", fontSize: 18 }}
                    ></i>
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <form onSubmit={(e) => pesquisar(e)}>
            <TextField
              id="pesquisar"
              label={labelPesquisar()}
              fullWidth
              value={buscaFiltro}
              margin="normal"
              onChange={(e) => setBuscaFiltro(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={pesquisar}>
                      <i
                        className="ph-bold ph-magnifying-glass"
                        style={{ color: "#494C62", fontSize: 18 }}
                      ></i>
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </form>
        )}
      </div>
    </div>
  );
};

export default ButtonFiltroAvancado;
